import React from 'react'
import {
  CFImage,
  CFView,
  CFText,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import ViewMenu from './ViewMenu'
import { hero, heroText, logo, mobileHero, mobileHeroText } from 'images'
import ViewMenuButton from './ViewMenuButton'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="95vh"
          maxHeight="750px"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
          justifyStart
          alignCenter
        >
          <CFImage
            src={mobileHeroText}
            w="90%"
            maxWidth="300px"
            mt="30px"
            alt="About"
          />
          <CFView column center textCenter mt="25px">
            <CFView h1 white xBold>
              ONLINE ORDER
            </CFView>
            <CFView h1 white xBold>
              NOW AVAILABLE!
            </CFView>
            <CFView pulsate textCenter pt="20px" mb="5px" w="80%">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="690px"
          w="100%"
          image={`url(${hero}) center / cover no-repeat`}
          zIndex={90}
          column
          justifyBetween
          alignCenter
        >
          <Header />
          <CFView row center bg="rgba(198,0,0,0.6)" ph="100px">
            <CFView h1 white xBold mr="25px">
              ORDER ONLINE NOW!
            </CFView>
            <CFView pulsate pt="4px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
